import Vue from 'vue'

// Замена запятых на точки на лету
export const changeCommasOnDots = {
    methods: {
        changeCommasOnDots: function(event) {
            event.target.value = event.target.value.replace(",", ".")
            event.target.value = event.target.value.replace(/[^0-9\.]/g,"")
        }
    }
}

// Готовим номера для ТС на лету
export const filterTSNames = {
    methods: {
        filterTSNames: function(event) {
            event.target.value = event.target.value.replace(" ", "")
            event.target.value = event.target.value.replace("   ", "")
            event.target.value = event.target.value.replace(/[^0-9\АВЕКМНОРСТУХ]/g,"")
        }
    }
}

// Готовим гос номер
export const validGosNumber = {
    methods: {
        validGosNumber: function(event) {
            if (event.target.value.length <= 9) {
                event.target.value = event.target.value.replace(" ", "")
                event.target.value = event.target.value.replace("   ", "")
                event.target.value = event.target.value.replace(/[^0-9\АВЕКМНОРСТУХ]/g,"")
            } else {
                event.target.value = event.target.value.substring(0, 9)
            }
        }
    }
}

// Преобразование сумм
export const toCurrency = {
    methods: {
        toCurrency(value) {
            if (typeof value !== "number") {
                return value
            }
            let formatter = new Intl.NumberFormat('ru-RU', {
                minimumFractionDigits: 0
            })
            return formatter.format(value)
        }
    }
}

export const toShortMillions = {
  methods: {
    toShortMillions(value, digits = 2) {
      if (typeof value !== "number") {
        return value
      }

      return Math.abs(value) > 999 ? Math.sign(value)*((Math.abs(value)/1000000).toFixed(digits)) : Math.sign(value)*Math.abs(value)
    }
  }
}

// Преобразование даты
const moment = require('moment')
require('moment/locale/ru')
Vue.use(require('vue-moment'), { moment })
Vue.prototype.moment = moment

export const formattedDate = {
    methods: {
        formattedDate(date) {
            let formatDate = moment(date).format('DD.MM.YYYY')
            if (formatDate == 'Invalid date') {
                // Step 1: Validation
                if (!date || typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
                    return "Не указана";
                }

                // Step 2: Flexible Formatting
                formatDate = moment(date, ['YYYY-MM-DD']).format('DD.MM.YYYY');
                if (!formatDate || formatDate === 'Invalid date') {
                    return "Не указана";
                }
            }

            return formatDate;
        }
    }
}

// Преобразование даты со временем
export const formattedDateTime = {
    methods: {
        formattedDateTime(date) {
            let formatDate = moment(date).format('DD.MM.YYYY HH:mm')
            if (formatDate == 'Invalid date') return "Не указана"
            return formatDate
        }
    }
}

// Форматирование номера телефона
export const phoneMask = {
    methods: {
        phoneMask(phone) {
            if (!!phone) {
                phone = phone.replace(/\D/g, '')
                const match = phone.match(/^(\d{1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})$/)
                if (match) {
                    phone = `+${match[1] === '8' ? '7' : match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]} `
                }
                return phone
            }
        }
    }
}

// Обрезка значений в инпутах на лету
export const maxCharsLimit = {
    methods: {
        maxCharsLimit(maxLength, valueId, objectId = 'editedItem') {
            if (this[objectId][valueId].length >= maxLength) {
                this[objectId][valueId] = this[objectId][valueId].substring(0, maxLength)
            }
        }
    }
}

// Кавычки фильтрация и валидация
export const validateAndReplaceQuotes = {
    data () {
        return this._initialData()
    },
    methods: {
        _initialData() {
            return {
                validateCompanyName: {
                    validName: '',
                    errorText: '',
                    countQuotes: 0,
                    doubleQuotes: false,
                    valid: true

                }
            }
        },
        _clearValidateQuotes() {
            Object.assign(this.$data, this._initialData())
        },
        replacementQuotes(value) {
            this._clearValidateQuotes()
            if (!!value) {
                this.validateCompanyName.validName = value.split('').map(symbol => {
                    if (symbol === '«' || symbol === '»' || symbol === "'") {
                        return '"'
                    }
                    return symbol
                }).join('')
                return this.validateCompanyName.validName
            } else {
                return value
            }

        },
        validateQuotesText() {
            if (!!this.validateCompanyName.validName) {
                this.validateCompanyName.validName.split('').forEach((symbol, index, array) => {
                    if (symbol === '"') {
                        this.validateCompanyName.countQuotes++
                        this.validateCompanyName.doubleQuotes = array[index - 1] === '"'
                    }
                })
                switch (true) {
                    case this.validateCompanyName.countQuotes === 1:
                        this.validateCompanyName.valid = false
                        this.validateCompanyName.errorText = 'В названии компании должно быть более одной кавычки!'
                        break;
                    case this.validateCompanyName.countQuotes === 2 && this.validateCompanyName.doubleQuotes:
                        this.validateCompanyName.valid = false
                        this.validateCompanyName.errorText = 'Кавычки ничего не обрамляют!'
                        break;
                    case this.validateCompanyName.countQuotes > 2:
                        this.validateCompanyName.valid = false
                        this.validateCompanyName.errorText = 'В названии компании должно быть не более двух кавычек!'
                        break;
                    default:
                        this.validateCompanyName.valid = true
                }
            }
        }
    }
}



